export const convertCents = (cents) => {
     // and round up to the nearest dollar
     return Math.floor(cents/100)
}